import { Skeleton } from '../skeleton';

/**
 * アクティビティ（営業履歴）リストのスケルトンUI
 * @param count - 表示するスケルトンアイテムの数（デフォルト: 5）
 */
export function ActivityListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <ul className="divide-y divide-stone-200">
      {Array.from({ length: count }).map((_, index) => (
        <li key={index} className="gap-sm px-lg py-md flex items-center">
          <Skeleton className="h-12 w-12 rounded-full" />
          <div className="flex-1 space-y-sm">
            <div className="gap-md flex items-center">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-5 w-20" />
            </div>
            <div className="gap-sm flex items-center">
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-4 w-48" />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
